const en = {
  "nav.agentia": "AI Agent",
  "nav.sectors": "Sectors",
  "nav.pricing": "Pricing",
  "nav.contact": "Contact",
  "hero.badge": "✦ Powered by AIPreneur",
  "hero.title.1": "Deploy an AI agent",
  "hero.title.2": "voice and text",
  "hero.title.3": "that works for you 24/7.",
  "hero.subtitle": "A custom AI employee for internal and external use. Capture leads, assist your teams, automate customer support.",
  "hero.cta.primary": "Discover the AI Agent",
  "hero.cta.secondary": "View pricing",
  "stats.sectors": "Sectors covered",
  "stats.availability": "Flows processed",
  "stats.response": "Response time",
  "stats.costs": "Satisfaction",
  "features.title": "Everything your business needs",
  "features.1.title": "External Agent (Clients)",
  "features.1.desc": "Capture leads, respond to clients 24/7 and automate order tracking.",
  "features.2.title": "Multi-language",
  "features.2.desc": "FR, EN, ES, AR and 50+ languages natively supported.",
  "features.3.title": "Native integrations",
  "features.3.desc": "CRM, email, WhatsApp, Slack, n8n, Make. Perfect symbiosis.",
  "features.4.title": "Internal Agent (Team)",
  "features.4.desc": "Centralize internal processes, train your teams and accelerate productivity.",
  "features.5.title": "Intelligent human escalation",
  "features.5.desc": "Transfer to human agent when necessary, without friction.",
  "features.6.title": "Analytics Dashboard",
  "features.6.desc": "Track conversions, analyze savings and monitor performance in real-time.",
  "chat.title": "See your AI Agent in action",
  "chat.status": "AIpreneur Agent · Online",
  "chat.msg1": "Hello, what are your opening hours?",
  "chat.msg2": "Hello! We're available 24/7. How can I help you?",
  "chat.msg3": "I have an issue with my order #4521",
  "chat.msg4": "I'm locating your order. Delivery expected tomorrow before 6pm. Would you like to be notified?",
  "chat.resolved": "Resolved in 8 seconds · 0 human intervention",
  "testimonials.title": "What they say",
  "testimonials.1.quote": "The Agent responds to my clients with more elegance than some of my salespeople. Deployed in 2 weeks.",
  "testimonials.1.name": "Marie D.",
  "testimonials.1.role": "CEO · Jewelry Boutique",
  "testimonials.2.quote": "Our LTV increased by 34% since deployment. The Agent qualifies and feeds our CRM in real-time.",
  "testimonials.2.name": "Thomas R.",
  "testimonials.2.role": "CTO · FinTech SaaS",
  "testimonials.3.quote": "Our patients are taken care of at any hour. GDPR perfectly respected. Essential.",
  "testimonials.3.name": "Sophie M.",
  "testimonials.3.role": "Director · Private Clinic",
  "testimonials.1.sector": "Luxury",
  "testimonials.2.sector": "FinTech",
  "testimonials.3.sector": "Healthcare",
  "faq.title": "Frequently asked questions",
  "faq.1.q": "How long does deployment take?",
  "faq.1.a": "Deployment time varies: generally between 1 and 2 weeks for the most complex cases.",
  "faq.2.q": "Is my sector compatible?",
  "faq.2.a": "AIpreneur Agent adapts to over 30 sectors. If yours isn't listed, contact us for a custom deployment.",
  "faq.3.q": "Can I customize the Agent's tone?",
  "faq.3.a": "Absolutely. Tone, vocabulary, formality level, language — each parameter is calibrated to your brand identity.",
  "faq.4.q": "Does the Agent replace my teams?",
  "faq.4.a": "No. The Agent augments your teams. It handles repetitive flows and intelligently escalates to humans when necessary.",
  "faq.5.q": "What channels are supported?",
  "faq.5.a": "Web, WhatsApp, email, Slack, QR codes, phone, custom APIs. The Agent lives wherever your clients communicate.",
  "faq.6.q": "How does billing work?",
  "faq.6.a": "Text agent: monthly plans. Voice agent: setup + pay-per-use. No minimum commitment.",
  "faq.7.q": "Can I test before committing?",
  "faq.7.a": "Yes. Contact us for a personalized demonstration with your real use case.",
  "faq.8.q": "What geographic areas do you cover?",
  "faq.8.a": "France, Luxembourg, Belgium, Switzerland, Morocco, Algeria and Tunisia.",
  "cta.title": "Ready to deploy your AI Agent?",
  "cta.subtitle": "Deployment in 1 to 2 weeks. No commitment.",
  "cta.primary": "See pricing",
  "cta.secondary": "Book a call",
  "footer.tagline": "The custom AI Agent for your business.",
  "footer.powered": "Powered by AIPreneur",
  "footer.nav": "Navigation",
  "footer.home": "Home",
  "footer.zones.title": "Covered areas",
  "footer.zones": "France, Luxembourg, Belgium, Switzerland, Morocco, Algeria, Tunisia",
  "footer.legal.title": "Legal",
  "footer.mentions": "Legal notice",
  "footer.privacy": "Privacy policy",
  "footer.rights": "© 2026 AIPreneur. All rights reserved.",
  "agent.hero.badge": "✦ The Platform",
  "agent.hero.title.1": "Your AI Agent +",
  "agent.hero.title.2": "Complete dashboard.",
  "agent.hero.subtitle": "Total control via a clear dashboard to manage your AI Agent, track requests, view conversion statistics and analyze your team's performance and savings.",
  "agent.anatomie.title": "Anatomy of an Action",
  "agent.anatomie.subtitle": "It's not a conversation. It's a decision.",
  "agent.step1.title": "The Impulse",
  "agent.step1.desc": "A request arrives. The Agent absorbs the intent in 0.3s — beyond language, beyond channel.",
  "agent.step1.badge": "0.3s",
  "agent.step2.title": "The Synthesis",
  "agent.step2.desc": "The Agent traverses your business database. It doesn't search — it knows.",
  "agent.step2.badge": "Analysis",
  "agent.step2.pills": "Airtable,CRM,Business DB",
  "agent.step3.title": "The Execution",
  "agent.step3.desc": "Contract sent. Calendar booked. Prospect qualified. Zero human intervention.",
  "agent.step3.badge": "Done",
  "agent.memoire.title": "Cognitive Memory",
  "agent.memoire.subtitle": "Each interaction is a lesson. The Agent extracts the essence of each conversation, qualifies the intent and feeds your CRM in real-time.",
  "agent.memoire.scoring": "INTUITIVE SCORING",
  "agent.memoire.scoring.sub": "Intent detected",
  "agent.memoire.tag1": "#Purchase",
  "agent.memoire.tag2": "#Urgent",
  "agent.memoire.tag3": "#B2B",
  "agent.memoire.tag4": "#France",
  "agent.memoire.tag5": "#Premium",
  "agent.memoire.extraction": "Intent Extraction",
  "agent.memoire.crm.title": "Real-Time CRM Flow",
  "agent.memoire.crm.1": "Company X — Added 2s ago",
  "agent.memoire.crm.2": "Lead #1247 — Score: 91 — Qualified",
  "agent.memoire.crm.3": "Company Y — Follow-up scheduled",
  "agent.memoire.crm.4": "Lead #1248 — Score: 78 — In progress",
  "agent.memoire.terminal.q": "> How many qualified leads this week?",
  "agent.memoire.terminal.a": "→ 47 prospects. High intent rate: 68%",
  "agent.memoire.terminal.title": "Dialogue with Data",
  "agent.memoire.ind1": "Imminent purchase",
  "agent.memoire.ind2": "B2B profile",
  "agent.memoire.ind3": "Emotion +",
  "agent.tissu.title": "The Connective Tissue",
  "agent.tissu.subtitle": "The Agent adapts to your world, not the other way around. A perfect symbiosis powered by n8n, Make, custom API.",
  "agent.tissu.sub2": "AIPreneur's 5 years of expertise at the heart of every connection.",
  "agent.tissu.pill1": "Native n8n",
  "agent.tissu.pill2": "Make",
  "agent.tissu.pill3": "Custom API",
  "agent.instinct.title": "Instinct — Beyond the model",
  "agent.instinct.subtitle": "The Agent doesn't ask you which model to choose. It chooses alone — the most precise, the fastest, the most economical — at every moment, in silence.",
  "agent.instinct.center": "AIpreneur Instinct",
  "agent.cta.title": "Bring your AI Agent to life",
  "agent.cta.subtitle": "1 to 2 weeks to deploy an intelligence that understands, decides and acts.",
  "secteurs.hero.title.1": "30+ sectors,",
  "secteurs.hero.title.2": "one solution.",
  "secteurs.hero.subtitle": "The AIpreneur Agent adapts to your profession by absorbing your professional DNA.",
  "secteurs.search.placeholder": "Search your sector...",
  "secteurs.meta.title": "Concrete use cases",
  "secteurs.meta.subtitle": "Three universes. Three personalities. One Agent.",
  "secteurs.meta.1.title": "E-commerce",
  "secteurs.meta.1.tone": "Reactive · Precise · Available",
  "secteurs.meta.1.client": "Where is my order #4521?",
  "secteurs.meta.1.entity": "Your order is being delivered. Expected arrival tomorrow before 6pm.",
  "secteurs.meta.2.title": "Healthcare",
  "secteurs.meta.2.tone": "Caring · Reassuring · Confidential",
  "secteurs.meta.2.client": "I would like to make an appointment for a check-up.",
  "secteurs.meta.2.entity": "Of course. I'll offer you a suitable slot. All your data remains confidential.",
  "secteurs.meta.3.title": "Banking & Finance",
  "secteurs.meta.3.tone": "Precise · Secure · Fast",
  "secteurs.meta.3.client": "What is my current account balance?",
  "secteurs.meta.3.entity": "Your balance is €3,247.50. Would you like to see your recent transactions?",
  "secteurs.process.title": "The Assimilation Process",
  "secteurs.process.subtitle": "How the Agent learns a new profession — silently, deeply.",
  "secteurs.process.1.title": "Ingestion",
  "secteurs.process.1.desc": "Connection to your business data via n8n/Make. The Agent absorbs without judging.",
  "secteurs.process.1.pills": "n8n,Make,API",
  "secteurs.process.2.title": "Alignment",
  "secteurs.process.2.desc": "Calibration of tone, vocabulary and personality. The Agent fades to become you.",
  "secteurs.process.2.pills": "Tone,Vocabulary,Personality",
  "secteurs.process.3.title": "Deployment",
  "secteurs.process.3.desc": "The Agent becomes autonomous. It streamlines your processes and grows with your business.",
  "secteurs.process.3.badge": "1-2 weeks · Autonomous · Growing",
  "secteurs.cta.title": "Your sector deserves an Agent tailored to it",
  "secteurs.cta.subtitle": "Discover how the AIpreneur Agent adapts to your reality.",
  "secteurs.default.badge": "Custom profession",
  "secteurs.default.entity": "Your sector is unique. The Agent will align to it in 1 to 2 weeks.",
  "secteurs.response.tone": "Adapted tone",
  "tarifs.hero.badge": "✦ Three plans adapted to your ambitions",
  "tarifs.hero.title": "Invest in your growth.",
  "tarifs.hero.subtitle": "Text or voice AI Agent — choose the plan that fits your needs.",
  "tarifs.toggle.monthly": "Monthly",
  "tarifs.toggle.annual": "Annual",
  "tarifs.toggle.save": "-20%",
  "tarifs.clarte.title": "Absolute clarity",
  "tarifs.clarte.subtitle": "No hidden fees. No surprises. Each plan is transparent.",
  "tarifs.clarte.1.title": "No commitment",
  "tarifs.clarte.1.desc": "Cancel whenever you want, without penalty.",
  "tarifs.clarte.2.title": "Deployment included",
  "tarifs.clarte.2.desc": "Configuration, customization and go-live included.",
  "tarifs.clarte.3.title": "Training included",
  "tarifs.clarte.3.desc": "Support for your team.",
  "tarifs.clarte.4.title": "Continuous updates",
  "tarifs.clarte.4.desc": "Your Agent evolves with the latest LLM models.",
  "tarifs.cta.title": "Ready to take it to the next level?",
  "tarifs.cta.subtitle": "Contact us for a personalized demonstration.",
  "tarifs.guarantee.1": "30-day money back guarantee",
  "tarifs.guarantee.2": "Deployment guaranteed 1-2 weeks",
  "tarifs.guarantee.3": "Dedicated support",
  "tarifs.guarantee.4": "GDPR Native",
  "tarifs.faq.title": "Questions about plans",
  "tarifs.faq.1.q": "Can I change plans along the way?",
  "tarifs.faq.1.a": "Yes, you can upgrade to a higher plan at any time. The difference is calculated pro rata.",
  "tarifs.faq.2.q": "What happens if I exceed my monthly conversations?",
  "tarifs.faq.2.a": "We alert you before reaching the limit. You can upgrade or purchase additional conversations.",
  "tarifs.faq.3.q": "Is deployment really included?",
  "tarifs.faq.3.a": "Yes. Complete configuration, tone customization and integration with your existing flows. Everything is included.",
  "tarifs.faq.4.q": "Is there a minimum contract?",
  "tarifs.faq.4.a": "No. Monthly commitment without minimum. Annual Vision with -20% discount.",
  "contact.hero.badge": "✦ Let's talk about your project",
  "contact.hero.title": "Deploy your AI Agent.",
  "contact.hero.subtitle": "Fill out the form below and our team will contact you within 24h.",
  "contact.calendly.title": "Or book a slot directly",
  "contact.calendly.cta": "Book on Calendly",
  "contact.info.title": "Information",
  "contact.info.email": "contact@aipreneur.ma",
  "contact.info.location": "France, Luxembourg, Belgium, Switzerland, Morocco, Algeria, Tunisia",
  "contact.info.certif": "On-site and remote services",
  "legal.title": "Legal notice",
  "legal.editor.title": "Site editor",
  "legal.editor.text": "AIPreneur SAS\nRegistered office: France\nSIRET: Registration in progress\nPublication director: AIPreneur",
  "legal.hosting.title": "Hosting",
  "legal.hosting.text": "The site is hosted within the European Union, in compliance with GDPR requirements.\nHost: Hostinger International Ltd.\nAddress: 61 Lordou Vironos, 6023 Larnaca, Cyprus",
  "legal.ip.title": "Intellectual property",
  "legal.ip.text": "All content on the aipreneur.fr site (texts, images, logos, videos, source code) is protected by copyright and remains the exclusive property of AIPreneur SAS.",
  "legal.liability.title": "Liability",
  "legal.liability.text": "AIPreneur strives to ensure the accuracy of published information. However, no guarantee is given as to the completeness or timeliness of this information.",
  "privacy.title": "Privacy policy",
  "privacy.intro.title": "Introduction",
  "privacy.intro.text": "AIPreneur SAS is committed to protecting the privacy of its users.",
  "privacy.data.title": "Data collected",
  "privacy.data.text": "We only collect data necessary for the proper functioning of our services:\n• Identification data: name, first name, email, phone\n• Connection data: IP address, access logs\n• Navigation data: pages visited, session duration",
  "privacy.purpose.title": "Purpose of processing",
  "privacy.purpose.text": "Your data is processed to:\n• Respond to your contact requests\n• Improve our services\n• Meet our legal obligations",
  "privacy.storage.title": "Storage and security",
  "privacy.storage.text": "Your data is hosted exclusively within the European Union.",
  "privacy.rights.title": "Your rights",
  "privacy.rights.text": "Under GDPR, you have rights of access, rectification, erasure, portability and objection.",
  "privacy.cookies.title": "Cookies",
  "privacy.cookies.text": "The site uses strictly necessary cookies.",
  "compare.title": "Before a standard chatbot. After a voice & text AI agent from AIpreneur.",
  "compare.subtitle": "A solution designed to respond, qualify, guide, convert and automate, on the web, by message and by voice, without blocking your teams.",
  "compare.col.capability": "Capabilities",
  "compare.col.before": "Before: standard chatbot",
  "compare.col.after": "After: AIpreneur AI agent",
  "compare.row1.cap": "Understanding requests",
  "compare.row1.before": "Fixed responses, often limited to a few scenarios",
  "compare.row1.after": "Contextual understanding with text and voice responses",
  "compare.row2.cap": "User experience",
  "compare.row2.before": "Rigid interaction, often frustrating journey",
  "compare.row2.after": "More fluid, natural and action-oriented conversation",
  "compare.row3.cap": "Voice + text",
  "compare.row3.before": "Usually text only",
  "compare.row3.after": "Same conversational logic for voice and text",
  "compare.row4.cap": "Lead qualification",
  "compare.row4.before": "Little or no real qualification",
  "compare.row4.after": "Automatic qualification according to defined business criteria",
  "compare.row5.cap": "Appointment booking",
  "compare.row5.before": "Often requires manual intervention",
  "compare.row5.after": "Appointment, callback or transfer triggered automatically according to scenario",
  "compare.row6.cap": "Multichannel",
  "compare.row6.before": "Often limited to a single channel",
  "compare.row6.after": "Web, message, QR code, phone or other channels depending on integration",
  "compare.row7.cap": "Business integration",
  "compare.row7.before": "Poorly connected to internal tools",
  "compare.row7.after": "Possible connection to CRM, calendar, support and business workflows",
  "compare.row8.cap": "Performance monitoring",
  "compare.row8.before": "Little visibility on results",
  "compare.row8.after": "KPIs, volume, delays, conversion and operational tracking",
  "compare.conclusion": "AIpreneur doesn't just respond: it helps process, qualify, guide and convert more effectively.",
  "compare.cta": "Discover the AI agent",
};

export default en;
